module.exports = "/assets/data/a827d4e32e72741df252e95e939c1d3f-WC2R.data.json";